export default __webpack_public_path__ + "static/case2_img_1@2x-fc54965d0d1f8ca55f5abef393240e49.webp";